// AddonCard.jsx
export default function AddonCard({ 
  title, 
  price, 
  period, 
  description, 
  features, 
  badge, 
  accent = false 
}) {
  return (
    <div className={`addon-card ${accent ? 'accent' : ''}`}>
      {badge && <div className="addon-badge">{badge}</div>}
      
      <div className="addon-header">
        <h4 className="addon-title">{title}</h4>
        <div className="addon-pricing">
          <span className="price">{price}</span>
          <span className="period">{period}</span>
        </div>
      </div>
      
      <p className="addon-description">{description}</p>
      
      <ul className="addon-features">
        {features.map((feature, index) => (
          <li key={index} className="feature-item">
            <span className="feature-icon">✓</span>
            {feature}
          </li>
        ))}
      </ul>
      
      <a href="#contact" className={`btn ${accent ? "btn-accent" : ""}`} 
           style={{ width: "100%", textAlign: "center" }}>
          Get Started
        </a>
      {/* <button className="addon-cta">
        Add to Package
        <span className="cta-icon">+</span>
      </button> */}
    </div>
  );
}